export default __webpack_public_path__ + "static/media/photo2-445x299.f3be02a6.jpg";